// extracted by mini-css-extract-plugin
export default {"wrapper":"kp-z","response":"lp-z","error":"mp-z","disabled":"np-z","buttons":"op-z","feedbackQuestionSection":"pp-z","yesNoWrapper":"qp-z"};